import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getLeftTopNotice } from 'views/BootGuide/service';

export const notices = createQueryKeys('notices', {
  leftTopNotice: (aiEnable?: boolean) => ({
    queryKey: [aiEnable],
    queryFn: ({ signal }) => getLeftTopNotice(aiEnable, signal),
  }),
});
